import { Link } from "react-router-dom";
import { MODES } from "../WordyWhiz/stacks/constants";
import { ModeMiniGrid, LearnIcon, isStrictMode } from "../WordyWhiz/stacks/ModeIcon";

const STATS = [
  { value: "4", label: "Game modes" },
  { value: "115K+", label: "Words" },
  { value: "Free", label: "No signup to play" },
];

function TileRow({ letters }) {
  return (
    <div className="home-tile-row">
      {letters.map((ch, i) => (
        <span key={i} className="ww-tile">{ch}</span>
      ))}
    </div>
  );
}

function Home() {
  return (
    <div className="home-page">
      <section className="home-hero">
        <div className="home-hero__copy">
          <p className="ww-label">Word game &amp; flashcard trainer</p>
          <h1 className="home-headline">
            Learn a word. <em>Then go drop it on the board.</em>
          </h1>
          <p className="home-subhead">
            Sharpen your vocabulary with flashcards, or unwind by dropping
            letters into words. It's the kind of distraction that's actually
            good for you.
          </p>
          <div className="home-hero__actions">
            <Link to="/wordy-whiz/stacks/classic" className="ww-btn ww-btn--primary">Play Stacks</Link>
            <Link to="/wordy-whiz/dictionaries" className="ww-btn ww-btn--secondary">Study a list</Link>
          </div>
          <div className="home-stats">
            {STATS.map((stat) => (
              <div key={stat.label} className="home-stat">
                <span className="home-stat__value">{stat.value}</span>
                <span className="ww-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="home-hero__tiles" aria-hidden="true">
          <TileRow letters={["W", "O", "R", "D", "Y"]} />
          <TileRow letters={["W", "H", "I", "Z"]} />
        </div>
      </section>

      <section className="home-modes">
        <p className="ww-label">Two ways in</p>
        <div className="mode-grid">
          <Link to="/wordy-whiz/dictionaries" className="mode-card mode-card--learn">
            <LearnIcon />
            <span className="mode-card__name">Learn</span>
            <span className="mode-card__tagline">Flashcards to build your vocabulary</span>
          </Link>
          {Object.values(MODES).map((mode) => (
            <Link key={mode.id} to={`/wordy-whiz/stacks/${mode.id}`} className="mode-card">
              <ModeMiniGrid mode={mode} />
              <span className="mode-card__name">{mode.name}</span>
              <span className="mode-card__tagline">{mode.tagline}</span>
              {isStrictMode(mode) && <span className="mode-card__strict">Strict · No partial credit</span>}
            </Link>
          ))}
        </div>
      </section>

      <p className="home-studio">
        Wordy Whiz is built by <Link to="/about">Good Distractions</Link>, a
        mobile app developer helping you find better ways to pass the time.
      </p>
    </div>
  );
}

export default Home;
